module.exports = __webpack_public_path__ + "static/elephant1-cf75d488cd3daae50c781f34ea45a207.jpeg";